module.exports = __webpack_public_path__ + "assets/img/yyindex-2.71b699ef.png";